import styles from './CreditCardform.module.scss'
import classNames from 'classnames'
import { AWCButton } from '../GlobalComponents/Inputs/Inputs'
import { InputLoader } from '../GlobalComponents/Inputs/Inputs'

interface props {
    creditCardType: string
    submmiting: boolean
    readyToSubmit: boolean
    handleClick(e: any): void
    error: string
    handleCancel(): void
}
export default function CreditCardForm({
    submmiting,
    readyToSubmit,
    handleClick,
    creditCardType,
    error,
    handleCancel,
}: props) {
    function getCardImageCss(name: string) {
        switch (name) {
        case 'visa':
            return styles.visaImage
        case 'master-card':
            return styles.masterCardImage
        case 'maestro':
            return styles.maestroImage
        case 'american-express':
            return styles.americanExpressImage
        case 'discover':
            return styles.discoverImage
        case 'jcb':
            return styles.jcbImage
        default:
            return ''
        }
    }
    return (
        <div className={styles.formContainer}>
            <div className={styles.pageTitleCC}>Add Credit Card</div>
            <form
                action="/"
                id="my-sample-form"
                method="post"
                className={classNames(styles.creditCardForm)}
            >
                <div className={styles.cardinfoCardName}>
                    <label className={styles.cardinfoLabel}>Card Holder Name</label>
                    <div className={styles.inputWrapper} id="cardholdername"></div>
                </div>

                <div className={styles.cardinfoCardName}>
                    <label className={styles.cardinfoLabel}>Card Number</label>
                    <div className={styles.inputWrapper} id="card-number">
                        <div
                            className={classNames(
                                styles.cardImage,
                                getCardImageCss(creditCardType)
                            )}
                            id="card-image"
                        ></div>
                    </div>
                </div>

                <div className={styles.cardinfoWrapper}>
                    <div className={styles.cardinfoCvv}>
                        <label className={styles.cardinfoLabel}>CVV</label>
                        <div className={styles.inputWrapper} id="cvv"></div>
                    </div>

                    <div className={styles.cardinfoExpDate}>
                        <label className={styles.cardinfoLabel}>Expiration Date</label>
                        <div className={styles.inputWrapper} id="expiration-date"></div>
                    </div>
                </div>
                <div className={styles.cardinfoCardName}>
                    <label className={styles.cardinfoLabel}>Zip Code</label>
                    <div className={styles.inputWrapper} id="postalCode"></div>
                </div>

                <div className={styles.cardinfoCardName}>
                    {submmiting ? (
                        <InputLoader
                            style={{
                                maxHeight: 15,
                                marginLeft: 10,
                                width: 15,
                                float: 'right',
                            }}
                        />
                    ) : (
                        <label className={styles.errorLabel}>{error}</label>
                    )}
                </div>
                <div className={styles.formBottom}>
                    <AWCButton
                        onClick={handleCancel}
                        style={{ flex: '80px 0 0', marginRight: 11 }}
                        type={'secondary'}
                    >
                        Cancel
                    </AWCButton>
                    <AWCButton
                        onClick={(e) => handleClick(e)}
                        style={{ flex: '80px 0 0', marginRight: 11 }}
                        type={readyToSubmit ? 'primary' : 'disabled'}
                    >
                        Save
                    </AWCButton>
                </div>
            </form>
        </div>
    )
}
